import { customAlphabet } from "nanoid";
const nanoid = customAlphabet("1234567890abcdefghijklmnopqrstuvwxyz", 10);
export default nanoid;

export function uniqueIdFromGroup(group: { id?: string }[]): string {
  let id = nanoid(5);
  while (group.some((item) => item.id === id)) id = nanoid(5);
  return id;
}
